// extracted by mini-css-extract-plugin
export default {"home":"Home_home__oOG6v","home__cardContainer":"Home_home__cardContainer__Gu6dS"};